// extracted by mini-css-extract-plugin
module.exports = {"accountEditBlock":"layout_container_accountEditBlock__t2XzQ","stepsProfileBlock":"layout_container_stepsProfileBlock__Pv_zg","main":"layout_container_main__aquJr"};